import { Component, Input, OnInit } from '@angular/core';
import {
  IGetBookingsAirResponse,
  ISectorAir
} from "../../service/resources/booking/interfaces/IGetBookings";
import { faArrowRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { ILabels } from "../../interfaces/ILabels";
import { Yii } from "../../interfaces/Yii";

interface ISeatStatusSector {
  quantity: number;
  cabin: string;
  code: string;
  status: string;
  xStatus: string;
}

@Component({
  selector: 'seat-status-sector',
  template: `
    <div class="seatStatusSector" *ngFor="let seatStatusSector of seatsStatusSector; let last = last" [title]="seatStatusSector.xStatus" [class]="seatStatusSector.xStatus">
      <span>
        {{seatStatusSector.cabin}}
        {{wording.class}}&nbsp;{{seatStatusSector.code}}
        {{seatStatusSector.status}}
        * {{seatStatusSector.quantity}}
      </span>
      <fa-icon [icon]="iconArrowRight" *ngIf="!last"></fa-icon>&nbsp;
    </div>
  `,
  styles: [`
    :host {
      display: flex;
    }
    .seatStatusSector.undefined span {
      color: #8a6d3b;
    }
    .seatStatusSector.cancel span {
      color: #a94442;
    }
    /*.seatStatusSector.confirm span {
      color: green;
    }*/
  `]
})
export class SeatStatusSectorComponent implements OnInit {
  @Input()
  public booking: IGetBookingsAirResponse;
  public iconArrowRight: IconDefinition = faArrowRight;
  public wording: ILabels = {
    class: Yii.t('wui-watabi-js', 'Classe')
  };
  public seatsStatusSector: ISeatStatusSector[] = [];

  public ngOnInit(): void {
    this.initSeatsStatusSector();
  }

    private initSeatsStatusSector(): void {
      this.booking?.sector?.forEach((sector: ISectorAir) => {
        if (sector.seat) {
          this.seatsStatusSector.push({
            cabin: sector.seat.cabin,
            code: sector.seat.code,
            quantity: sector.seat.quantity,
            status: sector.seat.status,
            xStatus: sector.seat.xStatus
          });
        }
      });
    }
  }
/*
*             <ul class="trip">
                <ng-container *ngFor="let stop of trip; let last = last">
                    <li>
                        <span [title]="stop?.city?.name || '?'">{{ stop?.airport?.code || "?"}}</span>
                        <fa-icon [icon]="iconArrowRight" *ngIf="!last" ></fa-icon>
                    </li>
                </ng-container>
            </ul> */
